import React from 'react';
import NavigationItem from './NavigationItem/NavigationItem'
import NavigationLink from './NavigationLink/NavigationLink'
import NavigationAccordion from './NavigationAccordion/NavigationAccordion'
import ListGroup from 'react-bootstrap/ListGroup';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import classes from './Navigation.css'


function renderNavItem(index, element, props) {
  return (
    <NavigationItem
      key={element['name'] + index}
      name={element['name']}
      src={element['src']}
      selected={props.selectedItems[0] === index ?  true : false}
      setContentPath={props.setContentPath}
      setAccordionKeys={props.setAccordionKeys}
      itemPath={'/' + element['name'].replace(/\s+/g, '')}
      itemIndex={[index]}
    />
  );
};

function renderNavLink(index, element, props) {
  return (
    <NavigationLink
      key={element['name'] + index}
      name={element['name']}
      src={element['src']}
      itemIndex={[index]}
      setAccordionKeys={props.setAccordionKeys}
    />
  );
};

function renderNavAccordion(index, element, props) {
  return (
    <NavigationAccordion
      key={element['name'] + index}
      name={element['name']}
      items={element['items']}
      selectedItems={props.selectedItems}
      setContentPath={props.setContentPath}
      setAccordionKeys={props.setAccordionKeys}
      accordionKeys={[...props.accordionKeys].splice(1)}
      itemPath={'/' + element['name'].replace(/\s+/g, '')}
      itemIndex={[index]}
    />
  );
};

const navigation = (props) => {
  let navElements = props.navData['items'].map(
    (element, i) => {
      if (element['type'] === 'navItem') {
        return renderNavItem(i, element, props);
      }
      else if (element['type'] === 'navLink') {
        return renderNavLink(i, element, props);
      }
      else if (element['type'] === 'navAccordion') {
        return renderNavAccordion(i, element, props);
      }
      return undefined;
    }
  ).filter(Boolean);

  return (
    <div className='navigation'>
      <Accordion activeKey={props.accordionKeys[0]}>
        {navElements}
      </Accordion>
    </div>
  )
};

export default navigation
